import OccasionState from './occasion-state';
import { reduce, filter } from 'microstates';

export default class OccasionSelectListState {
  occasions = [OccasionState]

  selectFrom(title) {
    return this.occasions.map(o => {
      return o.title.state === title
        ? o.select()
        : o.deselect()
    });
  }

  deselectMessages() {
    return this.occasions.map(o => o.messages.map(m => m.deselect()));
  }

  get selected() {
    let t = this;
    const { selected } = reduce(t.occasions, (acc, val) => {
      if (acc.selected) {
        return acc;
      }
      return val.isSelected.state
        ? (() => {
          acc.selected = val;
          return acc;
        })()
        : acc;
    }, { selected: null, t });

    return selected;
  }
}
